/**
 * Buy X Get Y / Buy X Get Discount plugin
 * 规则：在购物车中满足条件时，自动添加赠品或在结账时自动附加折扣码。
 * - 使用主题内置发布/订阅（pubsub.js）监听购物车更新
 * - 使用 Shopify 路由（window.routes.*）进行加购与数量调整
 */
(function() {
  /**
   * 读取配置
   * 可通过 window.BOGO_CONFIG 覆盖默认规则；默认不启用，仅提供示例结构
   */
  var DEFAULT_CONFIG = {
    enabled: false,
    rules: [
      /** 示例：买 2 件 A，送 1 件 B */
      {
        type: 'buy_x_get_y',
        buy_variant_id: 0,
        buy_qty: 2,
        gift_variant_id: 0,
        gift_per_group: 1,
        remove_on_disqualify: true
      },
      /** 示例：买 3 件 C，结账自动附加折扣码 CODE10 */
      {
        type: 'buy_x_get_discount',
        buy_variant_id: 0,
        buy_qty: 3,
        discount_code: 'CODE10'
      }
    ]
  };

  /**
   * 安全读取当前配置
   */
  function getConfig() {
    var cfg = (window.BOGO_CONFIG && typeof window.BOGO_CONFIG === 'object') ? window.BOGO_CONFIG : DEFAULT_CONFIG;
    return cfg || DEFAULT_CONFIG;
  }

  /**
   * 从 cartData 或 /cart.js 获取购物车状态
   * 返回 { items: Array<{id:number, quantity:number}>, item_count:number }
   */
  function getCartState(cartData) {
    return new Promise(function(resolve) {
      try {
        if (cartData && Array.isArray(cartData.items)) {
          resolve(cartData);
          return;
        }
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(json) { resolve(json); })
          .catch(function(err) { console.error('[BOGO] cart.js error', err); resolve({ items: [], item_count: 0 }); });
      } catch (err) {
        console.error('[BOGO] getCartState error', err);
        resolve({ items: [], item_count: 0 });
      }
    });
  }

  /**
   * 计算满足次数（组数）
   */
  function countGroups(items, variantId, threshold) {
    try {
      var qty = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === variantId) qty += items[i].quantity;
      }
      return Math.floor(qty / threshold);
    } catch (err) {
      console.error('[BOGO] countGroups error', err);
      return 0;
    }
  }

  /**
   * 返回购物车中某变体的数量
   */
  function getVariantQty(items, variantId) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === variantId) return items[i].quantity;
    }
    return 0;
  }

  /**
   * 建立购物车变体数量映射 { variantId: qty }
   */
  function buildVariantQtyMap(items) {
    var map = {};
    for (var i = 0; i < items.length; i++) {
      var id = items[i].id;
      map[id] = (map[id] || 0) + items[i].quantity;
    }
    return map;
  }

  /**
   * 汇总某集合规则的总数量
   */
  function sumQtyForList(variantQtyMap, list) {
    var total = 0;
    if (!Array.isArray(list)) return 0;
    for (var i = 0; i < list.length; i++) {
      total += (variantQtyMap[list[i]] || 0);
    }
    return total;
  }

  /**
   * 满足金额与件数阈值（可选）
   */
  function meetsGlobalThresholds(cart, rule) {
    try {
      var subtotalCents = cart && (cart.total_price || cart.current_total_price) || 0;
      var minSubtotalCents = null;
      if (rule && rule.min_subtotal !== undefined && rule.min_subtotal !== null && rule.min_subtotal !== '') {
        var val = parseFloat(rule.min_subtotal);
        if (!isNaN(val)) minSubtotalCents = Math.round(val * 100);
      }
      var minItems = (rule && rule.min_items_total) ? parseInt(rule.min_items_total) : 0;
      var itemsCount = cart && cart.item_count ? parseInt(cart.item_count) : 0;

      if (minSubtotalCents !== null && subtotalCents < minSubtotalCents) return false;
      if (minItems > 0 && itemsCount < minItems) return false;
      return true;
    } catch (err) {
      console.error('[BOGO] meets thresholds error', err);
      return false;
    }
  }

  /**
   * 调整某变体数量（可用于添加/移除赠品）
   */
  function setVariantQty(variantId, qty) {
    var body = JSON.stringify({
      updates: (function(){ var o = {}; o[variantId] = qty; return o; })(),
      sections: ['cart-icon-bubble', 'cart-drawer', 'main-cart-items', 'main-cart-footer'],
      sections_url: window.location.pathname
    });
    return fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig(), { body: body }))
      .then(function(r){ return r.text(); })
      .then(function(state){
        var parsed = JSON.parse(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bogo', cartData: parsed });
        return parsed;
      })
      .catch(function(err){ console.error('[BOGO] setVariantQty error', err); });
  }

  /**
   * 应用折扣码：通过 /discount/CODE 重定向，之后返回购物车或结账
   */
  function applyDiscount(code, redirectToCheckout) {
    try {
      if (!code) { window.location.assign('/checkout'); return; }
      var target = redirectToCheckout ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout' : '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      window.location.assign(target);
    } catch (err) {
      console.error('[BOGO] applyDiscount error', err);
    }
  }

  /**
   * 处理买 X 送 Y 规则
   */
  function handleBuyXGetY(cart, rule) {
    var groups = countGroups(cart.items, rule.buy_variant_id, rule.buy_qty);
    var needed = groups * (rule.gift_per_group || 1);
    var current = getVariantQty(cart.items, rule.gift_variant_id);

    if (needed > 0 && current !== needed) {
      console.log('[BOGO] adjust gift qty', { variant: rule.gift_variant_id, needed: needed, current: current });
      return setVariantQty(rule.gift_variant_id, needed);
    }
    if (needed === 0 && rule.remove_on_disqualify && current > 0) {
      console.log('[BOGO] remove gift', { variant: rule.gift_variant_id });
      return setVariantQty(rule.gift_variant_id, 0);
    }
    return Promise.resolve(cart);
  }

  /**
   * 处理买 X 送折扣规则
   */
  function handleBuyXGetDiscount(cart, rule) {
    var groups = countGroups(cart.items, rule.buy_variant_id, rule.buy_qty);
    if (groups > 0 && meetsGlobalThresholds(cart, rule)) {
      queueDiscountCandidate({ code: (rule.code || rule.discount_code), priority: rule.priority || 1, threshold: rule.buy_qty, label: rule.label });
    } else {
      clearDiscountIfMatch(rule.code || rule.discount_code);
    }
  }

  /**
   * 处理集合内任意产品折扣（collections_any_discount）
   */
  function handleCollectionsAny(cart, rule) {
    var map = buildVariantQtyMap(cart.items);
    var total = sumQtyForList(map, rule.variant_ids);
    if (total >= (rule.min_total_qty || 1) && meetsGlobalThresholds(cart, rule)) {
      queueDiscountCandidate({ code: (rule.code || rule.discount_code), priority: rule.priority || 1, threshold: rule.min_total_qty, label: rule.label });
    } else {
      clearDiscountIfMatch(rule.code || rule.discount_code);
    }
  }

  /**
   * 处理不同集合折扣（collections_distinct_discount）
   */
  function handleCollectionsDistinct(cart, rule) {
    var map = buildVariantQtyMap(cart.items);
    var count = 0;
    var minEach = rule.min_each_qty || 1;
    if (Array.isArray(rule.collections_map)) {
      for (var i = 0; i < rule.collections_map.length; i++) {
        var entry = rule.collections_map[i];
        var qty = sumQtyForList(map, entry.variant_ids);
        if (qty >= minEach) count++;
      }
    }
    if (count >= (rule.distinct_collections_required || 2) && meetsGlobalThresholds(cart, rule)) {
      queueDiscountCandidate({ code: (rule.code || rule.discount_code), priority: rule.priority || 1, threshold: count, label: rule.label });
    } else {
      clearDiscountIfMatch(rule.code || rule.discount_code);
    }
  }

  /**
   * 处理站内任意产品折扣（site_any_products_discount）
   */
  function handleSiteAnyProducts(cart, rule) {
    var map = buildVariantQtyMap(cart.items);
    var total = 0;
    if (rule.global) {
      for (var k in map) total += map[k];
    } else {
      total = sumQtyForList(map, rule.product_variant_ids);
    }
    if (total >= (rule.min_total_qty || 1) && meetsGlobalThresholds(cart, rule)) {
      queueDiscountCandidate({ code: (rule.code || rule.discount_code), priority: rule.priority || 1, threshold: rule.min_total_qty, label: rule.label });
    } else {
      clearDiscountIfMatch(rule.code || rule.discount_code);
    }
  }

  /**
   * 折扣候选：只保留一个（不叠加）。优先级最高；同优先级取阈值更高；仍相同保留现有。
   */
  function queueDiscountCandidate(candidate) {
    try {
      var current = sessionStorage.getItem('bogo_pending_discount');
      var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta') || '{}');
      if (!current) {
        sessionStorage.setItem('bogo_pending_discount', candidate.code);
        sessionStorage.setItem('bogo_pending_meta', JSON.stringify({ priority: candidate.priority, threshold: candidate.threshold, label: candidate.label }));
        return;
      }
      // 比较优先级
      if ((candidate.priority || 1) > (meta.priority || 1)) {
        sessionStorage.setItem('bogo_pending_discount', candidate.code);
        sessionStorage.setItem('bogo_pending_meta', JSON.stringify({ priority: candidate.priority, threshold: candidate.threshold, label: candidate.label }));
        return;
      }
      if ((candidate.priority || 1) === (meta.priority || 1) && (candidate.threshold || 0) > (meta.threshold || 0)) {
        sessionStorage.setItem('bogo_pending_discount', candidate.code);
        sessionStorage.setItem('bogo_pending_meta', JSON.stringify({ priority: candidate.priority, threshold: candidate.threshold, label: candidate.label }));
      }
    } catch (err) {
      console.error('[BOGO] queue candidate error', err);
    }
  }

  function clearDiscountIfMatch(code) {
    try {
      var current = sessionStorage.getItem('bogo_pending_discount');
      if (current && current === code) {
        sessionStorage.removeItem('bogo_pending_discount');
        sessionStorage.removeItem('bogo_pending_meta');
      }
    } catch (err) { /* noop */ }
  }

  /**
   * 初始化：订阅购物车更新并绑定结账按钮事件
   */
  function init() {
    var cfg = getConfig();
    if (!cfg.enabled || !cfg.rules || !cfg.rules.length) {
      console.info('[BOGO] disabled or no rules');
      return;
    }

    // 订阅购物车更新
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(evt){
      return getCartState(evt && evt.cartData).then(function(cart){
        var best = null;
        cfg.rules.forEach(function(rule){
          try {
            if (rule.type === 'buy_x_get_y') {
              handleBuyXGetY(cart, rule);
            } else if (rule.type === 'buy_x_get_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleBuyXGetDiscount(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after, label: meta.label, priority: meta.priority, threshold: meta.threshold };
                }
              }
            } else if (rule.type === 'collections_any_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleCollectionsAny(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after, label: meta.label, priority: meta.priority, threshold: meta.threshold };
                }
              }
            } else if (rule.type === 'collections_mix_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleCollectionsDistinct(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after, label: meta.label, priority: meta.priority, threshold: meta.threshold };
                }
              }
            } else if (rule.type === 'site_any_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleSiteAnyProducts(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after, label: meta.label, priority: meta.priority, threshold: meta.threshold };
                }
              }
            }
          } catch (err) {
            console.error('[BOGO] rule error', err);
          }
        });

        // 重置为最佳候选或清空
        if (best) {
          sessionStorage.setItem('bogo_pending_discount', best.code);
          sessionStorage.setItem('bogo_pending_meta', JSON.stringify({ label: best.label, priority: best.priority, threshold: best.threshold }));
          // 始终在购物车页应用并覆盖为最佳折扣码，确保直观展示与优先度切换
          try {
            var last = sessionStorage.getItem('bogo_last_applied_on_cart');
            if (best.code && best.code !== last) {
              sessionStorage.setItem('bogo_last_applied_on_cart', best.code);
              applyDiscount(best.code, false);
            }
          } catch(e){}
        } else {
          sessionStorage.removeItem('bogo_pending_discount');
          sessionStorage.removeItem('bogo_pending_meta');
          sessionStorage.removeItem('bogo_last_applied_on_cart');
        }
      });
    });

    // 结账按钮拦截：有待应用折扣码时，重定向到 /discount/CODE 再进入结账
    document.addEventListener('click', function(e){
      var target = e.target.closest('button[name="checkout"], .cart__checkout-button[name="checkout"]');
      if (!target) return;
      e.preventDefault();
      getCartState().then(function(cart){
        var best = null;
        cfg.rules.forEach(function(rule){
          try {
            if (rule.type === 'buy_x_get_y') {
              handleBuyXGetY(cart, rule);
            } else if (rule.type === 'buy_x_get_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleBuyXGetDiscount(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after };
                }
              }
            } else if (rule.type === 'collections_any_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleCollectionsAny(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after };
                }
              }
            } else if (rule.type === 'collections_mix_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleCollectionsDistinct(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after };
                }
              }
            } else if (rule.type === 'site_any_discount') {
              var before = sessionStorage.getItem('bogo_pending_discount');
              handleSiteAnyProducts(cart, rule);
              var after = sessionStorage.getItem('bogo_pending_discount');
              if (after) {
                var meta = JSON.parse(sessionStorage.getItem('bogo_pending_meta')||'{}');
                if (!best || (meta.priority||1) > (best.priority||1) || ((meta.priority||1)===(best.priority||1) && (meta.threshold||0)>(best.threshold||0))) {
                  best = { code: after };
                }
              }
            }
          } catch(err) { }
        });
        if (best && best.code) {
          applyDiscount(best.code, true);
        } else {
          window.location.assign('/checkout');
        }
      });
    }, true);

    // 首次初始化也评估一次当前购物车
    getCartState().then(function(cart){
      cfg.rules.forEach(function(rule){
        try {
          if (rule.type === 'buy_x_get_y') {
            handleBuyXGetY(cart, rule);
          } else if (rule.type === 'buy_x_get_discount') {
            handleBuyXGetDiscount(cart, rule);
          } else if (rule.type === 'collections_any_discount') {
            handleCollectionsAny(cart, rule);
          } else if (rule.type === 'collections_mix_discount') {
            handleCollectionsDistinct(cart, rule);
          } else if (rule.type === 'site_any_discount') {
            handleSiteAnyProducts(cart, rule);
          }
        } catch (err) {
          console.error('[BOGO] init rule error', err);
        }
      });

    });
  }

  try { init(); } catch (err) { console.error('[BOGO] init error', err); }
})();
